/**
 * Where the travel quote reports its state once a Sort & Filter panel governs
 * the page.
 *
 * `TravelPolicySearch` sits above the two-column row, so its footer rendered as
 * a second, full-width results panel with its own count and empty state
 * (CMS-1542, Kok Fu 22 Sep). Portalling it here puts that reporting in the
 * results column beside the panel, which is the only place the reader is told
 * what the results are.
 */
export const TI_QUOTE_STATUS_SLOT_ID = 'ti-quote-status';
